
import { defineComponent, ref } from 'vue'
import { useForm } from 'vee-validate'
import { object } from 'yup'
import { myValidationSchemaObj, validationMessage } from '@/views/validation'
import ContentLayout from '@/views/layout/ContentLayout.vue'

interface InputForm {
  currentPassword: string;
  newPassword: string;
}

const validationSchema = object({
  currentPassword: myValidationSchemaObj.password,
  newPassword: myValidationSchemaObj.password
})

export default defineComponent({
  components: {
    ContentLayout
  },
  setup () {
    const confirmPassword = ref<string>('')
    const requestError = ref<string | null>(null)
    const { errors, values, meta, validate, setFieldError } = useForm<InputForm>({
      validationSchema: validationSchema,
      validateOnMount: false
    })

    const updatePassword = () => {
      if (values.newPassword !== confirmPassword.value) {
        setFieldError('newPassword', validationMessage.notMatchNewPassword)
      }
    }

    return {
      requestError,
      confirmPassword,
      values,
      errors,
      meta,
      validate,
      updatePassword
    }
  }
})
